import prodotti_fetch from "../../fetch/prodotti_fetch";
import create_autocompleteWithService from "./create_autocompleteWithService";

const AutocompliteProdotti = create_autocompleteWithService({
    freeinput: true,
    service: (myValue, serviceValues) => prodotti_fetch.get({
        nomeCodice: myValue,
        ...serviceValues,
    }),
    itemCompare: (item, inputValue) => (item.descrizione + ' ' + item.rifInterno)?.toLowerCase().indexOf((inputValue || "")?.toLowerCase()) !== -1,
    itemToLi: item => item.descrizione + ' - ' + item.rifInterno + '' + (item.infoFornitore !== null ? ' - ' + item.infoFornitore.nome : ' '),
    itemToString: item => item.descrizione + ' - ' + item.rifInterno,
    itemFind: (value, items) => items.reduce((acc, curr) => acc || (curr?.nome.toLowerCase() === value?.toLowerCase() ? curr : null), null)
});

export default AutocompliteProdotti